import { render } from "./TerrainView.vue?vue&type=template&id=4b0ba09d"
import script from "./TerrainView.vue?vue&type=script&lang=js"
export * from "./TerrainView.vue?vue&type=script&lang=js"
script.render = render

export default script